<div class="admin-container">
    <h2 id="modal-title">Admin Management</h2>

    <mat-tab-group animationDuration="0ms" class="admin-tabs">

        <!-- TAB 1: USERS -->
        <mat-tab label="Users">
            <div class="tab-content">

                <!-- Card 1: User Overview & Stats -->
                <div class="admin-card">
                    <div class="card-header">
                        <h4>User overview</h4>
                    </div>
                    <div class="stats-grid">
                        <div class="stat-box">
                            <span class="stat-label">Total users</span>
                            <span class="stat-value">{{ getTotalUsersCount() }}</span>
                        </div>
                        <div class="stat-box" *ngFor="let sub of subscriptions">
                            <span class="stat-label">{{ sub.name }} users</span>
                            <span class="stat-value">{{ getUsersCountBySubscription(sub.name) }}</span>
                        </div>
                    </div>
                </div>

                <!-- Card 2: Users Management & Table -->
                <div class="admin-card">
                    <div class="card-header flex-header">
                        <h4>Users</h4>
                        <mat-form-field appearance="outline" class="search-field">
                            <mat-label>Search users...</mat-label>
                            <input matInput (keyup)="applyUserFilter($event)" placeholder="Search by email">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </div>

                    <div class="table-container">
                        <table mat-table [dataSource]="usersDataSource" class="full-width-table">

                            <!-- Email Column -->
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef> Email Address </th>
                                <td mat-cell *matCellDef="let user"> {{ user.email }} </td>
                            </ng-container>

                            <!-- Inline Subscription Dropdown Column -->
                            <ng-container matColumnDef="subscription">
                                <th mat-header-cell *matHeaderCellDef> Subscription </th>
                                <td mat-cell *matCellDef="let userSubscription">
                                    <mat-form-field appearance="outline" class="compact-select">
                                        <mat-select [value]="userSubscription.subscriptionId"
                                            (selectionChange)="onUserSubscriptionChange(userSubscription, $event.value)">
                                            <mat-option *ngFor="let sub of subscriptions" [value]="sub.id">
                                                {{ sub.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="lastLogin">
                                <th mat-header-cell *matHeaderCellDef> Last login </th>
                                <td mat-cell *matCellDef="let userSubscription"> {{ userSubscription.lastLogin | date:'mediumDate' }} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="userColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: userColumns;"></tr>
                        </table>
                    </div>
                </div>

            </div>
        </mat-tab>

        <!-- TAB 2: FEATURES -->
        <mat-tab label="Features">
            <div class="tab-content">

                <div class="admin-card">
                    <div class="card-header">
                        <h4>Features</h4>
                    </div>
                    <div class="feature-list">
                        <div class="feature-item" *ngFor="let feature of features">
                            <div class="feature-info">
                                <span class="feature-name">{{ feature.name }}</span>
                                <span class="feature-desc">{{ feature.description }}</span>
                            </div>
                            <mat-slide-toggle color="primary" [(ngModel)]="feature.enabled"
                                (change)="onFeatureToggle(feature)">
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>

            </div>
        </mat-tab>

        <!-- TAB 3: SUBSCRIPTIONS -->
        <mat-tab label="Subscriptions">
            <div class="tab-content">

                <!-- Card 1: Active Subscriptions Count -->
                <div class="admin-card">
                    <div class="card-header">
                        <h4>Active Subscriptions Summary</h4>
                    </div>
                    <div class="stats-grid">
                        <div class="stat-box" *ngFor="let usn of userSubscriptionNumbers">
                            <span class="stat-label">{{ usn.subscriptionName }}</span>
                            <span class="stat-value">{{ usn.numberOf }}</span>
                        </div>
                    </div>
                </div>

                <!-- Card 2: Features Per Subscription -->
                <div class="admin-card">
                    <div class="card-header">
                        <h4>Subscription Feature Matrix</h4>
                    </div>
                    <div class="matrix-container">
                        <table class="matrix-table">
                            <thead>
                                <tr>
                                    <th>Feature</th>
                                    <th *ngFor="let subscription of subscriptions" class="center-text">{{
                                        subscription.name }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let feature of features">
                                    <td>
                                        <strong>{{ feature.name }}</strong>
                                        <div class="feature-subtext">{{ feature.description }}</div>
                                    </td>
                                    <td *ngFor="let subscription of subscriptions" class="center-text">
                                        <mat-checkbox color="primary"
                                            [checked]="isFeatureEnabledForSubscription(subscription.id, feature.id)"
                                            (change)="onSubscriptionFeatureToggle(subscription.id, feature.id, $event.checked)">
                                        </mat-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </mat-tab>

    </mat-tab-group>
</div>